import React from "react";
import { motion } from "framer-motion";
import { NavLink } from "react-router-dom";
import { Helmet } from "react-helmet";

// You should add these CSS rules to your project's stylesheet (e.g., index.css)
/*
.video-responsive-wrapper {
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-top: 56.25%; 
}

.video-responsive-wrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  border: none;
}
*/

const DosAndDontsToGetaBankAccountForYourMSBBusiness = () => {
  const letterVariants = {
    hidden: { y: -50, opacity: 0 },
    visible: (index) => ({
      y: 0,
      opacity: 1,
      transition: {
        delay: index * 0.05, // Delay for each letter
        duration: 0.4,
        ease: "easeInOut",
      },
    }),
  };

  const title = "Do's & Don'ts to get a bank account /nfor your MSB business";

  return (
    <div>
      <Helmet>
        {/* Basic Meta Tags */}
        <title>
          Do's & Don'ts to get a bank account for your MSB business | MSB
        </title>
        <meta name="description" content="" />
        {/* Open Graph Meta Tags */}
        <meta
          property="og:title"
          content="Do's & Don'ts to get a bank account for your MSB business | MSB"
        />
        <meta property="og:description" content="" />
        <meta property="og:type" content="website" />
        {/* Twitter Meta Tags */}
      </Helmet>
      <main className="page_content">
        {/* Page Header - Start
        ================================================== */}
        <section
          id="overview"
          className="page_header text-center section_decoration overflow-hidden"
          style={{ background: "#333" }}
        >
          <div className="container">
            <h1 className="page_title text-white">
              Do's & Don'ts to get a bank account for your MSB business
            </h1>
            {/* <motion.h1
              className="page_title text-white"
              initial="hidden"
              animate="visible"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
                flexWrap: "wrap",
              }}
            >
              {title
                .replace(/\/n/g, "\n")
                .split("\n")
                .map((line, lineIndex) => (
                  <div
                    key={`line-${lineIndex}`}
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      justifyContent: "center",
                    }}
                  >
                    {line.split("").map((letter, charIndex) => {
                      const uniqueIndex = lineIndex * 30 + charIndex;
                      return (
                        <motion.span
                          key={`char-${lineIndex}-${charIndex}`}
                          custom={uniqueIndex}
                          initial="hidden"
                          animate="visible"
                          variants={letterVariants}
                          style={{
                            display: "inline-block",
                            marginRight: letter === " " ? "0.3rem" : "0",
                            whiteSpace: "pre",
                          }}
                        >
                          {letter}
                        </motion.span>
                      );
                    })}
                  </div>
                ))}
            </motion.h1> */}
            <ul className="breadcrumb_nav unordered_list justify-content-center d-none">
              <li>
                <NavLink to="/webinars">Webinars</NavLink>
              </li>
              <li className="active">
                <a href="#!">
                  How Email & Mobile Verification Can Cut Customer Onboarding
                  Costs
                </a>
              </li>
            </ul>
          </div>
        </section>
        {/* Page Header - End
        ================================================== */}
        {/* Contact Section - Start
        ================================================== */}
        <section className="contact_section section_space bg-dark">
          <div className="container">
            <div className="item_details_content p-3">
              <div className="d-flex justify-content-end mb-3">
                <NavLink to="/webinars" className="btn bg-primary text-dark">
                  ← Back
                </NavLink>
              </div>
              <img
                className="rounded-2 mb-5"
                src="assets/images/webinars/dosand-donts-to-get-a-bank-account-for-your-msb-business.png"
                alt="Do's & Don'ts to get a bank account for your MSB business"
              />
              {/* <h4>Title</h4> */}
              <p className="mb-2">
                On 1st July, MSB professionals across the UK came together for a
                focused session with <strong>Steve Allen</strong>, Head of Sales
                at Clear Junction, to unpack one of the industry's biggest
                hurdles — banking access. The conversation explored the real
                friction points MSBs face when approaching financial
                institutions, from onboarding complexities to long-term
                relationship management.
              </p>
              <p className="mb-5">
                With a format designed for open dialogue, the session encouraged
                live input, honest questions, and grounded answers — making
                space for practical insights shaped by real-world banking
                scenarios.
              </p>

              <div className="item_details_content p-3">
                <div className="row mb-5">
                  <div className="col-lg-3 col-md-3 col-12">
                    <div className="event-detail-bg mb-1">
                      <img
                        src="assets/images/event-banner/date.svg"
                        alt="Date"
                      />
                      <div className="text-white">
                        <h5 className="fw-bold mb-1 text-white">Date</h5>
                        <span>Tuesday, 01 July 2025</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-3 col-12">
                    <div className="event-detail-bg mb-1">
                      <img
                        src="assets/images/event-banner/time.svg"
                        alt="Time"
                      />
                      <div className="text-white">
                        <h5 className="fw-bold mb-1 text-white">Time</h5>
                        <span>01:00 PM BST</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-3 col-12">
                    <div className="event-detail-bg mb-1">
                      <img
                        src="assets/images/event-banner/platform.svg"
                        alt="Platform"
                      />
                      <div className="text-white">
                        <h5 className="fw-bold mb-1 text-white">Platform</h5>
                        <span>Google Meet</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-3 col-12">
                    <div className="event-detail-bg mb-1">
                      <img
                        src="assets/images/event-banner/attendance.svg"
                        alt="Attendance"
                      />
                      <div className="text-white">
                        <h5 className="fw-bold mb-1 text-white">Attendance</h5>
                        <span>95+ MSB Professionals</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row mb-4 mt-4 align-items-baseline">
                  <div className="col-lg-6 col-md-6 col-12">
                    <div className="schedule-date fw-bold fs-5">
                      What Was Covered
                    </div>
                    <div className="schedule-card">
                      <div className="schedule-item mb-2">
                        <ul>
                          <li>Overview of the Remittance Market</li>
                          <li>Banking Challenges for MSBs</li>
                          <li>Do’s & Don’ts of Onboarding</li>
                          <li>Cross-Border Payment Challenges</li>
                          <li>Rise of Stable coins</li>
                          <li>Advice for Scaling</li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-6 col-md-6 col-12">
                    <div className="schedule-date fw-bold fs-5">
                      What Made It Stand Out
                    </div>
                    <div className="schedule-card">
                      <div className="schedule-item mb-2">
                        <ul>
                          <li>Insights from a banking insider</li>
                          <li>Clear guidance on onboarding practices</li>
                          <li>Direct answers to MSB banking challenges</li>
                          <li>Discussion rooted in real industry scenarios</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row mb-4 mt-4 align-items-center">
                  <div className="col-lg-6 col-md-6 col-12">
                    <div className="schedule-date fw-bold fs-5">
                      Banking-Focused Highlights
                    </div>
                    <div className="schedule-card">
                      <div className="schedule-item mb-2">
                        <ul>
                          <li>
                            <strong>95+</strong> MSB leaders joined live
                          </li>
                          <li>
                            <strong>60 minutes</strong> on banking access &
                            onboarding
                          </li>
                          <li>Real questions, real banking answers</li>
                          <li>Actionable insights for MSB banking success</li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <hr className="d-block d-sm-none" />

                  <div className="col-lg-6 col-md-6 col-12">
                    <img
                      src="/assets/images/webinars/Steve-Allen.png"
                      alt="Event"
                      className="img-fluid rounded-2 d-none"
                    />
                    {/* ===== RESPONSIVE IFRAME START ===== */}
                    <div className="video-responsive-wrapper">
                      <iframe
                        src="https://www.youtube.com/embed/S7ZBXJCYvyc"
                        title="How MSBs Can Get Bank Accounts in 2025 | Expert Advice from Clear Junction"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin"
                        allowfullscreen
                      ></iframe>
                    </div>
                    {/* ===== RESPONSIVE IFRAME END ===== */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default DosAndDontsToGetaBankAccountForYourMSBBusiness;
